const RedSvgGradient = () => {
  return (
    <radialGradient
      id="redSvgGradient"
      cx="1"
      cy="1"
      r="3.5"
      gradientUnits="objectBoundingBox"
    >
      <stop offset="0.77%" stopColor="hsla(359, 100%, 30%, 0.9)" />
      <stop offset="60%" stopColor="hsla(305, 91%, 45%, 0.7)" />
    </radialGradient>
  );
};

const DefaultBarGradient = () => {
  return (
    <radialGradient
      id="barColor"
      cx="1.175"
      cy="1.7271"
      r="3"
      gradientUnits="objectBoundingBox"
    >
      <stop offset="0.77%" stopColor="hsla(212, 71%, 47%, 0.69)" />
      <stop offset="57.22%" stopColor="hsla(274, 91%, 45%, 0.69)" />
    </radialGradient>
  );
};

const OrangeYellowDotGradient = () => {
  return (
    <radialGradient
      id="orangeYellowDotGradient"
      cx="1"
      cy="1"
      r="3.5"
      gradientUnits="objectBoundingBox"
    >
      <stop offset="0%" stopColor="hsl(var(--custom-orange))" />
      <stop offset="100%" stopColor="hsl(var(--custom-yellow))" />
    </radialGradient>
  );
};

const TurquoiseBlueGreenGradient = () => {
  return (
    <radialGradient
      id="turquoiseBlueGreenGradient"
      cx="1"
      cy="1"
      r="3.5"
      gradientUnits="objectBoundingBox"
    >
      <stop offset="0%" stopColor="hsl(var(--custom-turquoise-blue))" />
      <stop offset="100%" stopColor="hsl(var(--custom-turquoise-green))" />
    </radialGradient>
  );
};

export {
  RedSvgGradient,
  DefaultBarGradient,
  OrangeYellowDotGradient,
  TurquoiseBlueGreenGradient,
};
